/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';

import { Message, Link } from 'src/core/components';

import './MoreInfo.style.scss';
import messages from './messages';

const MoreInfo = ({ link = '#' }) => (
  <div className="more-info-text">
    <Link href={link} target="_blank">
      <Message message={messages.moreInfo} />
    </Link>
  </div>
);

MoreInfo.propTypes = {
  link: PropTypes.string,
};

export default MoreInfo;
